import { HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllPersonOverviewIndicatorsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllPersonOverviewIndicators
  implements GetAllPersonOverviewIndicatorsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllPersonOverviewIndicatorsUseCaseInterface.Params,
  ): Promise<GetAllPersonOverviewIndicatorsUseCaseInterface.Result> {
    const { id, ...restParams } = params;

    const requestUrl = `${this.url}/indicators/${id}`;

    const httpResponse = await this.httpClient.request({
      url: generateUrl(requestUrl, restParams),
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
